import { useEffect } from 'react';

export default function SEOHead({ 
  title = "DOT | Crypto & iGaming Advertising Solutions",
  description = "175M+ engaged Crypto & iGaming users. Get conversions with DOT Ads, Meta Ads, PR Newswire, and Creative Design. Trusted by 5,000+ brands worldwide.",
  image = "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/690a28bada88e702ec8f793d/da70bf8dc_NwIcons7.png",
  url,
  type = "website"
}: any) {
  useEffect(() => {
    // Use current page URL if not provided
    const pageUrl = url || window.location.href;
    
    // Set document title
    document.title = title;

    // Helper function to set or update meta tags
    const setMetaTag = (property: string, content: string, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, property);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Set or update canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', pageUrl);

    // Standard meta tags
    setMetaTag('description', description, false);

    // Open Graph tags
    setMetaTag('og:title', title);
    setMetaTag('og:description', description);
    setMetaTag('og:image', image);
    setMetaTag('og:url', pageUrl);
    setMetaTag('og:type', type);
    setMetaTag('og:site_name', 'DOT Audiences');

    // Twitter Card tags
    setMetaTag('twitter:card', 'summary_large_image', false);
    setMetaTag('twitter:site', '@DotAudiences', false);
    setMetaTag('twitter:title', title, false);
    setMetaTag('twitter:description', description, false);
    setMetaTag('twitter:image', image, false);
  }, [title, description, image, url, type]);

  return null;
}